// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawing-menu-mobile{display:none}@media only screen and (max-width: 400px)and (max-height: 750px),screen and (max-width: 780px)and (max-height: 400px){.pagetitle h1{font-size:smaller}.drawing-menu-mobile{display:block}.drawing-menu{display:none}}", ""]);
// Exports
module.exports = exports;
